import { put } from "redux-saga/effects";

import { InternshipsAction } from "../actions";
import { ApiCaller } from "../../config";

export default class InternshipsMiddleware {
  static *getInternships({ payload, cb }) {
    try {
      const { search, date, location, jobType, company } = payload;

      const res = yield ApiCaller.Get(
        `/internships/get-jobs?search=${search ?? ""}&date=${
          date ?? ""
        }&location=${location ?? ""}&jobType=${jobType ?? ""}&company=${
          company ?? ""
        }`
      );

      if (res.status === 200) {
        yield put(InternshipsAction.getInternshipsSuccess(res.data.data));
      } else {
        yield put(InternshipsAction.getInternshipsSuccess([]));
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(InternshipsAction.getInternshipsFailure());
    }
  }
  static *getJobCompanies({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/internships/get-job-companies`);

      if (res.status === 200) {
        yield put(InternshipsAction.getJobCompaniesSuccess(res.data.data));
      } else {
        yield put(InternshipsAction.getJobCompaniesFailure([]));
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(InternshipsAction.getJobCompaniesFailure());
    }
  }
  static *getJobTypes({ cb }) {
    try {
      const res = yield ApiCaller.Get(`/internships/get-job-types`);

      if (res.status === 200) {
        yield put(InternshipsAction.getJobTypesSuccess(res.data.data));
      } else {
        yield put(InternshipsAction.getJobTypesFailure([]));
      }
      if (cb) {
        cb(res.data);
      }
    } catch (err) {
      yield put(InternshipsAction.getJobTypesFailure());
    }
  }
}
